import { CouponStatus } from 'API';

/**
 * maps coupon status to user-friendly text
 */
export const CouponStatusText: Record<CouponStatus, string> = {
  [CouponStatus.Applied]: 'Applied',
  [CouponStatus.NotApplied]: 'Not Applied',
} as const;
